<div *ngIf="formObject">
  <mat-form-field appearance="standard" class="w-100">
    <mat-label  [ngStyle]="isFirst ? {'visibility': 'visible'} : {'visibility' : 'hidden'}">
      {{'forms.common.input.degree.label' | translate}}
      <sup *ngIf="isInfo">
        <mat-icon class="fas fa-info" style="font-size: 0.5rem"></mat-icon>
      </sup>
    </mat-label>
    <mat-select [(ngModel)]="ngModelObject"
                [disabled]="isDisabled"
                [name]="elementName"
                [value]="ngModelObject"
                (valueChange)="emitValue($event)">
      <mat-option *ngFor="let degree of degrees" [value]="degree">{{degree}}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
